import { Application } from "stimulus";
import { definitions } from "stimulus:../controllers";

// we need to include this manually as the current builder doesnt currently support it
import { initializeHanamiUjs } from "../vendor/hanamiUjs";

import { appsignal } from "./appsignal";
import pathOf from "../functions/pathOf";

const application = Application.start();

// Enough to find the element in the markup, without its contents: a form's markup holds its CSRF
// token and the values the server rendered into it.
const describeElement = (element) => {
  const id = element.id ? `#${element.id}` : "";
  const controller = element.dataset.controller ? `[data-controller="${element.dataset.controller}"]` : "";

  return `${element.tagName.toLowerCase()}${id}${controller}`;
};

application.handleError = (error, message, detail) => {
  if (process.env.HANAMI_ENV === "development") {
    // propagate errors that happen inside Stimulus controllers
    throw error;
  } else {
    console.error(error, message, detail);
    let element;
    if (detail.element) {
      element = describeElement(detail.element);
    }

    const span = appsignal.createSpan((span) => {
      const tags = {
        framework: "Stimulus",
        message: message,
        element: element,
        url: pathOf(window.location.href),
      };
      return span.setTags(tags).setError(error);
    });

    appsignal.send(span);
  }
};

application.load(definitions);

initializeHanamiUjs();
